export default __webpack_public_path__ + "9903a5e3f4a3f5f1914c74bfd8c90faa.png";